import { IndexSort } from "@omni/types/api/search/algolia/shared/enum/indexSort.enum";
import { cn } from "@omni/utils/styles";
import { useState } from "react";
import { SingleValue } from "react-select";

import { Select } from "@/components/Form/Base/select.component";
import { SortItem } from "@/components/Search/SearchResults/StateComponents/Sort/sort.container";

type SortComponentProps = {
    items: Array<SortItem>;
    refinedItem?: SortItem;
    refine: (value: IndexSort) => void;
    className?: string;
};

const SortComponent = ({
    items,
    refinedItem,
    refine,
    className
}: SortComponentProps) => {
    const [optimisticValue, setOptimisticValue] = useState<
        SortItem | undefined
    >(refinedItem);

    const handleOnSelectChange = (option: SingleValue<SortItem>) => {
        if (!option) return;

        setOptimisticValue(option);
        refine(option.value);
    };

    return (
        <Select
            className={cn("tw:min-w-50", className)}
            openMenuOnFocus={true}
            classNamePrefix="select-box"
            options={items}
            isSearchable={false}
            blurInputOnSelect={true}
            value={optimisticValue}
            onChange={handleOnSelectChange}
        />
    );
};

export { SortComponent };
